// Vuetify
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import 'vuetify/styles';

import { customButtons } from '@/plugins/customButtons';

const savedTheme = localStorage.getItem('theme');
let defaultTheme = savedTheme || 'light';

if (savedTheme === 'system') {
  defaultTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const vuetify = createVuetify({
  components: {
    ...components,
    ...customButtons,
  },
  directives,
  theme: {
    defaultTheme,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
});

export default vuetify;
